/*
 * Pipeline Theme — Custom JavaScript
 * Safe place for custom behavior so theme updates are easier.
 */

(function () {
  // Keep custom scripts inside this IIFE to avoid leaking globals.

  /* ============================================================
   * 0) Petticoat Lane predictive search result count
   *    Pipeline requests a small result set. Keep the theme code
   *    untouched and safely raise predictive results to 8 per type.
   * ============================================================ */
  if (!window.__plPredictiveFetchPatched && typeof window.fetch === 'function') {
    var plOriginalFetch = window.fetch;

    window.fetch = function (input, init) {
      try {
        var rawUrl = typeof input === 'string' ? input : (input && input.url ? input.url : '');
        var isPredictiveSearch = rawUrl && (
          rawUrl.indexOf('/search/suggest') !== -1 ||
          rawUrl.indexOf('section_id=predictive-search') !== -1
        );

        if (isPredictiveSearch) {
          var parsedUrl = new URL(rawUrl, window.location.origin);
          parsedUrl.searchParams.set('resources[limit]', '8');
          parsedUrl.searchParams.set('resources[limit_scope]', 'each');
          var adjustedUrl = parsedUrl.toString();

          if (typeof input === 'string') {
            input = adjustedUrl;
          } else if (typeof Request !== 'undefined' && input instanceof Request) {
            input = new Request(adjustedUrl, input);
          }
        }
      } catch (error) {
        console.warn('Petticoat Lane predictive search adjustment skipped:', error);
      }

      return plOriginalFetch.call(this, input, init);
    };

    window.__plPredictiveFetchPatched = true;
  }

  /* ============================================================
   * 1) Collection Load More: fetch + append + auto-trigger
   *    Requires:
   *      - #pl-grid (product grid wrapper)
   *      - #pl-loadmore (wrapper) with data-next="next page url"
   * ============================================================ */
  document.addEventListener('DOMContentLoaded', function () {
    var grid = document.querySelector('#pl-grid');
    var wrap = document.querySelector('#pl-loadmore');
    var button = wrap ? wrap.querySelector('button, a') : null;

    if (!grid || !wrap || !button) return;

    var loading = false;
    var io = null;

    async function loadNextPage() {
      if (loading) return;

      var nextUrl = wrap.getAttribute('data-next');
      if (!nextUrl) return;

      loading = true;
      if ('disabled' in button) button.disabled = true;
      wrap.classList.add('is-loading');

      try {
        var res = await fetch(nextUrl, { credentials: 'same-origin' });
        if (!res.ok) throw new Error('Network error ' + res.status);

        var html = await res.text();
        var doc = new DOMParser().parseFromString(html, 'text/html');

        var nextGrid = doc.querySelector('#pl-grid');
        var nextWrap = doc.querySelector('#pl-loadmore');

        if (nextGrid && nextGrid.innerHTML) {
          grid.insertAdjacentHTML('beforeend', nextGrid.innerHTML);
        }

        if (nextWrap && nextWrap.getAttribute('data-next')) {
          wrap.setAttribute('data-next', nextWrap.getAttribute('data-next'));
          if ('disabled' in button) button.disabled = false;
        } else {
          if (io) io.disconnect();
          wrap.remove();
        }
      } catch (e) {
        console.error(e);
        window.location.href = wrap.getAttribute('data-next') || window.location.href;
      } finally {
        loading = false;
        wrap.classList.remove('is-loading');
      }
    }

    button.addEventListener('click', function (e) {
      e.preventDefault();
      loadNextPage();
    });

    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (ent) {
            if (ent.isIntersecting && !loading && !(button && button.disabled)) {
              loadNextPage();
            }
          });
        },
        { rootMargin: '300px 0px' }
      );
      io.observe(wrap);
    }
  });

  /* ============================================================
   * 2) Brands A–Z Overlay
   * ============================================================ */
  document.addEventListener('DOMContentLoaded', function () {
    var overlay = document.getElementById('BrandsOverlay');
    if (!overlay) return;

    var closeBtn = overlay.querySelector('[data-close]');
    var search = document.getElementById('BrandsSearch');

    var tabAll = document.getElementById('tabAll');
    var tabLing = document.getElementById('tabLing');
    var tabSwim = document.getElementById('tabSwim');
    var tabApp = document.getElementById('tabApp');
    var tabSleep = document.getElementById('tabSleep');

    var panelAll = document.getElementById('panelAll');
    var panelLing = document.getElementById('panelLing');
    var panelSwim = document.getElementById('panelSwim');
    var panelApp = document.getElementById('panelApp');
    var panelSleep = document.getElementById('panelSleep');

    function setSelected(which) {
      var map = {
        all: [tabAll, panelAll],
        lingerie: [tabLing, panelLing],
        swimwear: [tabSwim, panelSwim],
        apparel: [tabApp, panelApp],
        sleepwear: [tabSleep, panelSleep],
      };

      Object.keys(map).forEach(function (k) {
        var t = map[k][0], p = map[k][1];
        var active = k === which;
        if (t) t.setAttribute('aria-selected', String(active));
        if (p) p.hidden = !active;
      });
    }

    function filter(term) {
      overlay.querySelectorAll('.brands-overlay__list li').forEach(function (li) {
        li.style.display = term && !li.textContent.toLowerCase().includes(term) ? 'none' : '';
      });
    }

    function open(which) {
      overlay.hidden = false;
      overlay.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('brands-overlay--open');
      setSelected(which || 'all');

      if (search) {
        search.value = '';
        filter('');
        search.focus();
      }
    }

    function close() {
      overlay.hidden = true;
      overlay.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('brands-overlay--open');
    }

    tabAll && tabAll.addEventListener('click', function () { open('all'); });
    tabLing && tabLing.addEventListener('click', function () { open('lingerie'); });
    tabSwim && tabSwim.addEventListener('click', function () { open('swimwear'); });
    tabApp && tabApp.addEventListener('click', function () { open('apparel'); });
    tabSleep && tabSleep.addEventListener('click', function () { open('sleepwear'); });

    closeBtn && closeBtn.addEventListener('click', close);
    overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.getAttribute('aria-hidden') === 'false') close();
    });

    search && search.addEventListener('input', function () {
      filter(search.value.trim().toLowerCase());
    });

    document.addEventListener('click', function (e) {
      var a = e.target.closest('a');
      if (!a) return;

      var text = (a.textContent || '').trim().toLowerCase();
      var href = (a.getAttribute('href') || '').toLowerCase();

      if (text.includes('brands a') || text.includes('brands a→z') || text.includes('brands a->z') || href.includes('/pages/brands')) {
        e.preventDefault(); open('all'); return;
      }
      if (text.includes('view all lingerie brands') || text.includes('a–z lingerie brands') || text.includes('a-z lingerie brands')) {
        e.preventDefault(); open('lingerie'); return;
      }
      if (text.includes('view all swimwear brands') || text.includes('a–z swimwear brands') || text.includes('a-z swimwear brands')) {
        e.preventDefault(); open('swimwear'); return;
      }
      if (text.includes('view all apparel brands') || text.includes('a–z apparel brands') || text.includes('a-z apparel brands')) {
        e.preventDefault(); open('apparel'); return;
      }
      if (text.includes('view all sleepwear brands') || text.includes('a–z sleepwear brands') || text.includes('a-z sleepwear brands')) {
        e.preventDefault(); open('sleepwear'); return;
      }
    });

    var p = location.pathname.toLowerCase();
    if (p === '/pages/all-lingerie-brands') open('lingerie');
    if (p === '/pages/all-swimwear-brands') open('swimwear');
    if (p === '/pages/all-apparel-brands') open('apparel');
    if (p === '/pages/all-sleepwear-brands') open('sleepwear');
  });
})();
